import React from 'react';
import Avatar from '@mui/material/Avatar';

const images = require.context('../../assets/Currencies', false, /\.(svg|png|jpg|jpeg)$/);

const icons = images.keys().reduce((acc, path) => {
  const key = path.replace('./', '').replace(/\.(svg|png|jpg|jpeg)$/, '').toUpperCase();
  acc[key] = images(path);
  return acc;
}, {});

const CurrencyIcon = ({ currency = 'NONE', size = 32 }) => {
  const normalized = currency.trim().toUpperCase();

  // Si no existe el ícono, usa el fallback "none.jpg"
  const src = icons[normalized] || icons['NONE'] || null;

  return (
    <Avatar
      src={src}
      alt={normalized}
      sx={{
        width: size,
        height: size,
        bgcolor: '#f5f5f5',
        objectFit: 'contain',
      }}
    >
      {normalized[0]}
    </Avatar>
  );
}

const CurrencySymbol = {
  USD: "US$",
  EUR: "€",
  JPY: "¥",
  GBP: "£",
  AUD: "A$",
  CAD: "C$",
  CHF: "CHF",
  MXN: "MX$",

  get(code = "USD") {
    return this[code] || "$";
  }
};

const BalanceFormatter = {
  decimals: {
    USD: 2,
    EUR: 2,
    JPY: 0,
    GBP: 2,
    AUD: 2,
    CAD: 2,
    CHF: 2,
    MXN: 2,
  },

  round(balance, code = "USD") {
    const dec = this.decimals[code] ?? 2;
    //return Number(balance).toFixed(dec);
    return Number(balance)
    .toFixed(dec)
    .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }
};

const BalanceFormatterWithoutSpace = {
  decimals: {
    USD: 2,
    EUR: 2,
    JPY: 0,
    GBP: 2,
    AUD: 2,
    CAD: 2,
    CHF: 2,
    MXN: 2,
  },

  round(balance, code = "USD") {
    const dec = this.decimals[code] ?? 2;
    return Number(balance).toFixed(dec);
  }
};

export {CurrencyIcon, CurrencySymbol, BalanceFormatter, BalanceFormatterWithoutSpace}

